import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage, languages } from '../context/LanguageContext';
import '../styles/LanguageSwitcher.css';

const LanguageSwitcher = () => {
  const { currentLanguage, changeLanguage } = useLanguage();

  const languageOptions = [
    { code: languages.FR, label: '🇫🇷 FR' },
    { code: languages.EN, label: '🇬🇧 EN' },
    { code: languages.ES, label: '🇪🇸 ES' }
  ];

  return (
    <div className="language-switcher">
      {languageOptions.map((option) => (
        <motion.button
          key={option.code}
          className={`language-option ${currentLanguage === option.code ? 'active' : ''}`}
          onClick={() => changeLanguage(option.code)}
          whileHover={{ scale: 1.1 }}
          whileTap={{ scale: 0.95 }}
        >
          {option.label}
        </motion.button>
      ))}
    </div>
  );
};

export default LanguageSwitcher;
